package com.exura.features.planDistribution

import com.exura.features.localization.domain.model.BasicLangSet
import com.exura.features.localization.domain.model.Language
import com.exura.features.localization.domain.model.Localization

interface DistLang {
    val patientCode: PatientCode
    val options: Options

    val distributedSuccessfully: String
    val failedToDistributePlan: String
    val failedToSavePlan: String
    val patientCodeDistribution: String

    interface Options {
        val distributionOptions: String
        val generateQr: String
        val prePrinted: String
        val plansCode: String
        val patientsCode: String
        val qrGenerationComingSoon: String
        val prePrintedPlansComingSoon: String
        val accessCodeGenerationComingSoon: String
        val comingSoon: String
    }

    interface PatientCode {
        val success: String
        val selectDateAndTime: String
        val patientCodeLabel: String
        val send: String
        val dateTimeRequired: String
        val patientCodeCannotBeEmpty: String
    }
}

data object DistPolish : DistLang {
    override val patientCode = PatientCode
    override val options = Options

    override val distributedSuccessfully: String = "Wysłano plan"
    override val failedToDistributePlan: String = "Nie udało się przesłać planu"
    override val failedToSavePlan: String = "Nie udało się zapisać planu"
    override val patientCodeDistribution: String = "Wyślij na kod pacjenta"

    data object Options : DistLang.Options {
        override val distributionOptions: String = "Opcje wysyłki"
        override val generateQr: String = "Generuj QR"
        override val prePrinted: String = "Wydrukowane"
        override val plansCode: String = "Kod planu"
        override val patientsCode: String = "Kod pacjenta"
        override val qrGenerationComingSoon: String = "Generowanie QR już niedługo"
        override val prePrintedPlansComingSoon: String = "Wydruk już niedługo"
        override val accessCodeGenerationComingSoon: String = "Kod dostępu planu już niedługo"
        override val comingSoon: String = "Już niedługo"
    }

    data object PatientCode : DistLang.PatientCode {
        override val success: String = "Dostarczono"
        override val selectDateAndTime: String = "Wybierz datę i czas"
        override val patientCodeLabel: String = "Kod pacjenta"
        override val send: String = "Wyślij"
        override val dateTimeRequired: String = "Data i czas są wymagane"
        override val patientCodeCannotBeEmpty: String = "Kod pacjenta nie może być pusty"
    }
}

data object DistEnglish : DistLang {
    override val options = Options
    override val patientCode = PatientCode



    override val distributedSuccessfully: String = "Distributed successfully"
    override val failedToDistributePlan: String = "Failed to distribute plan"
    override val failedToSavePlan: String = "Failed to save plan"
    override val patientCodeDistribution: String = "Patient Code Distribution"

    data object Options : DistLang.Options {
        override val distributionOptions: String = "Distribution Options"
        override val generateQr: String = "Generate QR"
        override val prePrinted: String = "Pre-print"
        override val plansCode: String = "Plan's code"
        override val patientsCode: String = "Patient's code"
        override val qrGenerationComingSoon: String = "QR generation coming soon"
        override val prePrintedPlansComingSoon: String = "Pre-printed plans coming soon"
        override val accessCodeGenerationComingSoon: String = "Access code generation coming soon"
        override val comingSoon: String = "Coming Soon"
    }

    data object PatientCode : DistLang.PatientCode {
        override val success: String = "Delivered"
        override val selectDateAndTime: String = "Select Date and Time"
        override val patientCodeLabel: String = "Patient Code"
        override val send: String = "Send"
        override val dateTimeRequired: String = "Date and time is required"
        override val patientCodeCannotBeEmpty: String = "Patient code cannot be empty"
    }
}

private val distLangSet = BasicLangSet<DistLang>(
    mapOf(
        Language.POLISH to DistPolish,
        Language.ENGLISH to DistEnglish,
    )
)

val distLocalization = Localization<DistLang>(distLangSet)

/*
USAGE:
import com.exura.features.planDistribution.distLocalization

fun someFunction() {
    println(distLocalization.current.publicPlan.title)
}
*/
